export default __webpack_public_path__ + "static/media/symbol_Neuronotes.ab8c447b.png";